import SliderImage2 from "../../assets/images/png/home/business.webp";
import SliderImage3 from "../../assets/images/png/home/impact.webp";
import SliderImage1 from "../../assets/images/png/home/individual.webp";
import BusinessIcon from "../../assets/images/svg/business.svg";
import ImpactIcon from "../../assets/images/svg/love.svg";
import PersonIcon from "../../assets/images/svg/person.svg";

export const africa = [
  {
    id: 1,
    image: SliderImage1,
    icon: PersonIcon,
    title: "Utiva Learn",
    description: `We evolved our Utiva Learn, which delivers personalised AI-supportive learning, smart talent matching, and seamless global payroll — all in one platform.`,
    linkUrl: "/get-started",

    stats: [
      {
        name: "Students Trained",
        value: "200k+",
      },
      {
        name: "Hiring Rate",
        value: "85% ",
      },
      {
        name: "Countries",
        value: "19",
      },
    ],
  },
  {
    id: 2,
    image: SliderImage2,
    icon: BusinessIcon,
    title: "Utiva Hire",
    description: `Share your needs and let our AI agent handle talent search, assessment, and matching — fast.`,
    linkUrl: "/business",
    stats: [
      {
        name: "Skill Areas",
        value: "15+",
      },
      {
        name: "Talent Ecosystem",
        value: "150K+ ",
      },
      {
        name: "Countries",
        value: "19",
      },
    ],
  },
  {
    id: 3,
    image: SliderImage3,
    icon: ImpactIcon,
    title: "Utiva Pay",
    description: `Automated global payroll in 12+ Countries, compliance, and tax management for teams working across borders.`,
    linkUrl: "https://impact.utiva.io",
    stats: [
      {
        name: "Countries",
        value: "12+",
      },
      {
        name: "Indemnification",
        value: "$1M+",
      },
      {
        name: "Payroll Processing",
        value: "1 Min.",
      },
    ],
  },
];
